import { render, staticRenderFns } from "./AppCheckbox.vue?vue&type=template&id=1c98d46c&scoped=true"
import script from "./AppCheckbox.vue?vue&type=script&lang=js"
export * from "./AppCheckbox.vue?vue&type=script&lang=js"
import style0 from "./AppCheckbox.vue?vue&type=style&index=0&id=1c98d46c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c98d46c",
  null
  
)

export default component.exports